<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-11 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Contact Information</h3>
                    </div>
                    <div class="card-body">
                        <div>
                            <p class="card-text fs-17"><b>Authorized Representative 1</b></p>
                            <p class="card-text text-justify mb-0">Name of Representative</p>
                            <div class="row">
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>First Name<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep1.fname" :class="{ 'is-invalid': submitting && $v.rep1.fname.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Middle Name</label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep1.mname">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Last Name<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep1.lname" :class="{ 'is-invalid': submitting && $v.rep1.lname.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Suffix</label>
                                        <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="suffix_desc" :options="suffixes" :reduce="suffix_desc => suffix_desc.suffix_code" v-model="rep1.suffix_code" />

                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Date of Birth<span class="text-danger">*</span></label>
                                        <input-calendar class="form-control form-control-sm" :class="{'is-invalid': submitting && $v.rep1.date_birth.$error }" id="db1" v-model="rep1.date_birth" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" />
                                        <!-- <input type="date" class="form-control form-control-sm" v-model="rep1.date_birth" :class="{ 'is-invalid': submitting && $v.rep1.date_birth.$error }"> -->
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Sex<span class="text-danger">*</span></label>
                                        <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="gender_desc" :options="gender" :reduce="gender_desc => gender_desc.gender_id" v-model="rep1.gender_id" :class="{ 'vs-invalid': submitting && $v.rep1.gender_id.$error }" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Mobile Number<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm" v-model="rep1.mobile" :class="{ 'is-invalid': submitting && $v.rep1.mobile.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Landline</label>
                                        <input class="form-control form-control-sm" v-model="rep1.landline">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>E-mail Address<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm" v-model="rep1.email" :class="{ 'is-invalid': submitting && $v.rep1.email.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Government ID<span class="text-danger">*</span></label>
                                        <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="id_name" :options="gov_ids" :reduce="id_name => id_name.id_code" v-model="rep1.id_code" :class="{ 'vs-invalid': submitting && $v.rep1.id_code.$error }" />
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>ID Number<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm" v-model="rep1.id_num" :class="{ 'is-invalid': submitting && $v.rep1.id_num.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Date of Expiry<span class="text-danger">*</span></label>
                                        <input-calendar class="form-control form-control-sm" :class="{'is-invalid': submitting && $v.rep1.expiry_date.$error }" id="ed1" v-model="rep1.expiry_date" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" maxDate="12/31/2099" />
                                        <!-- <input type="date" class="form-control form-control-sm" v-model="rep1.expiry_date" :class="{ 'is-invalid': submitting && $v.rep1.expiry_date.$error }"> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label>Position<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep1.position" :class="{ 'is-invalid': submitting && $v.rep1.position.$error }">
                                    </div>
                                </div>

                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label>Upload Government Issued ID<span class="text-danger">*</span></label>
                                        <div class="input-group">
                                            <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="ref_att137" @change="uploadAttach($event, 'att137')">
                                            <input type="text" class="form-control form-control-sm ro" readonly :value="att.att137 ? att.att137.name : 'Choose a file..'" @click="browseRef('ref_att137')" :class="{ 'is-invalid': submitting && $v.att.att137.$error }">
                                            <div class="input-group-append">
                                                <button class="btn btn-sm btn-outline-primary" @click="browseRef('ref_att137')">
                                                    <span>{{ att.att137 ? 'Change' : 'Attach' }}</span>
                                                </button>
                                                <button v-if="att.att137" class="btn btn-sm btn-outline-primary ml-1" @click="viewAttachFile(att.att137)">View</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-1"></div>
                                <div class="col-lg-5">
                                    <div class="mt-md-4 pt-md-2">
                                        <button class="float-right btn btn-sm btn-outline-primary" @click="rep0=1">Add another representative</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div v-if="rep0==1">
                            <div class="row">
                                <div class="col-9">
                                    <p class="card-text fs-17"><b>Authorized Representative 2</b></p>
                                </div>
                                <div class="col-3">
                                    <div class="float-right">
                                        <button class="btn btn-sm btn-outline-danger" @click="removeRep2()">Remove</button>
                                    </div>
                                </div>
                            </div>

                            <p class="card-text text-justify mb-0">Name of Representative</p>
                            <div class="row">
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>First Name<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep2.fname" :class="{ 'is-invalid': submitting && $v.rep2.fname.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Middle Name</label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep2.mname">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Last Name<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep2.lname" :class="{ 'is-invalid': submitting && $v.rep2.lname.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Suffix</label>
                                        <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="suffix_desc" :options="suffixes" :reduce="suffix_desc => suffix_desc.suffix_code" v-model="rep2.suffix_code" />

                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Date of Birth<span class="text-danger">*</span></label>
                                        <input-calendar class="form-control form-control-sm" :class="{'is-invalid': submitting && $v.rep2.date_birth.$error }" id="db2" v-model="rep2.date_birth" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" />
                                        <!-- <input type="date" class="form-control form-control-sm" v-model="rep2.date_birth" :class="{ 'is-invalid': submitting && $v.rep2.date_birth.$error }"> -->
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Sex<span class="text-danger">*</span></label>
                                        <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="gender_desc" :options="gender" :reduce="gender_desc => gender_desc.gender_id" v-model="rep2.gender_id" :class="{ 'vs-invalid': submitting && $v.rep2.gender_id.$error }" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Mobile Number<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm" v-model="rep2.mobile" :class="{ 'is-invalid': submitting && $v.rep2.mobile.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Landline</label>
                                        <input class="form-control form-control-sm" v-model="rep2.landline">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>E-mail Address<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm" v-model="rep2.email" :class="{ 'is-invalid': submitting && $v.rep2.email.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Government ID<span class="text-danger">*</span></label>
                                        <v-select placeholder="- Select -" append-to-body :calculate-position="withPopper" label="id_name" :options="gov_ids" :reduce="id_name => id_name.id_code" v-model="rep2.id_code" :class="{ 'vs-invalid': submitting && $v.rep2.id_code.$error }" />
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>ID Number<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm" v-model="rep2.id_num" :class="{ 'is-invalid': submitting && $v.rep2.id_num.$error }">
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4">
                                    <div class="form-group">
                                        <label>Date of Expiry<span class="text-danger">*</span></label>
                                        <input-calendar class="form-control form-control-sm" :class="{'is-invalid': submitting && $v.rep2.expiry_date.$error }" id="ed2" v-model="rep2.expiry_date" v-input-mask data-inputmask-alias="datetime" data-inputmask-inputformat="mm/dd/yyyy" maxDate="12/31/2099" />
                                        <!-- <input type="date" class="form-control form-control-sm" v-model="rep2.expiry_date" :class="{ 'is-invalid': submitting && $v.rep2.expiry_date.$error }"> -->
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-lg-2">
                                    <div class="form-group">
                                        <label>Position<span class="text-danger">*</span></label>
                                        <input class="form-control form-control-sm text-uppercase" v-model="rep2.position" :class="{ 'is-invalid': submitting && $v.rep2.position.$error }">
                                    </div>
                                </div>


                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Upload Government Issued ID<span class="text-danger">*</span></label>
                                        <div class="input-group">
                                            <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="ref_att138" @change="uploadAttach($event, 'att138')">
                                            <input type="text" class="form-control form-control-sm ro" readonly :value="att.att138 ? att.att138.name : 'Choose a file..'" @click="browseRef('ref_att138')" :class="{ 'is-invalid': submitting && $v.att.att138.$error }">
                                            <div class="input-group-append">
                                                <button class="btn btn-sm btn-outline-primary" @click="browseRef('ref_att138')">
                                                    <span>{{ att.att138 ? 'Change' : 'Attach' }}</span>
                                                </button>
                                                <button v-if="att.att138" class="btn btn-sm btn-outline-primary ml-1" @click="viewAttachFile(att.att138)">View</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
            <ModalFile :attachFile="attachFile" />
        </div>

    </transition>
</template>
<script>
    import {
        apiRefAuthRepRegistry,
    } from "@js/api/applyLoanApi";

    import ModalFile from '@vues/ModalFile.vue';
    import moment from "moment";
    import {
        required,
        minLength,
        requiredIf,
        minValue,
        helpers,
    } from "vuelidate/lib/validators";
    import {
        createPopper
    } from "@popperjs/core";
    export default {
        components: {
            ModalFile
        },

        props: ["app_id", "bor_id"],
        data() {
            return {
                rep0: 0,
                submitting: 0,
                suffixes: [],
                gender: [],
                gov_ids: [],
                attachFile: {
                    url: null,
                    type: null,
                    name: null
                },
                att: {
                    att137: null,
                    att138: null,
                },
                rep1: {
                    fname: null,
                    mname: null,
                    lname: null,
                    suffix_code: null,
                    id_code: null,
                    id_num: null,
                    date_birth: null,
                    gender_id: null,
                    rep_type_id: null,
                    position: null,

                    mobile: null,
                    email: null,
                    landline: null,
                    expiry_date: null,
                    
                },
                rep2: {
                    fname: null,
                    mname: null,
                    lname: null,
                    suffix_code: null,
                    id_code: null,
                    id_num: null,
                    date_birth: null,
                    gender_id: null,
                    rep_type_id: null,
                    position: null,

                    mobile: null,
                    email: null,
                    landline: null,
                },
            };
        },


        validations: {
            att: {
                att137: {
                    required,
                },
                att138: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
            },

            rep1: {
                fname: {
                    required,
                },
                // mname: {
                //     required,
                // },
                lname: {
                    required,
                },
                id_num: {
                    required,
                },
                date_birth: {
                    required,
                },
                mobile: {
                    required,
                },
                email: {
                    required,
                },
                expiry_date: {
                    required,
                },
                position: {
                    required,
                },
                gender_id: {
                    required,
                },
                id_code: {
                    required,
                }
            },
            rep2: {
                fname: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                // mname: {
                //     required: requiredIf(function(obj) {
                //         return this.rep0 == 1;
                //     }),
                // },
                lname: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                id_num: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                date_birth: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                mobile: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                email: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                expiry_date: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                position: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                gender_id: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                },
                id_code: {
                    required: requiredIf(function(obj) {
                        return this.rep0 == 1;
                    }),
                }
            },
        },
        computed: {},
        created() {
            this.initData();
        },

        methods: {
            async initData() {
                this.$emit('load', 1);
                try {
                    const {
                        gender,
                        gov_ids,
                        suffixes
                    } = await apiRefAuthRepRegistry();
                    this.gender = gender;
                    this.gov_ids = gov_ids;
                    this.suffixes = suffixes;
                } catch (error) {
                    this.$emit('error', error);
                } finally {
                    this.$emit('load', -1);
                }
            },
            btnNext() {
                this.submitting = 1;
                this.$v.rep1.$touch();
                this.$v.rep2.$touch();
                this.$v.att.$touch();
                if (this.$v.rep1.$invalid || this.$v.rep2.$invalid || this.$v.att.$invalid) {
                    const err = {
                        response: {
                            data: {
                                message: "Please complete all required fields",
                            }
                        }
                    };
                    this.$emit('error', err);
                } else {
                    this.apiPostAuthRep();
                }
            },
            apiPostAuthRep() {
                this.$emit('load', 1);
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    },
                }
                let r1 = _.some(this.rep1, obj =>
                    _.some(_.values(obj), value => !_.isEmpty(value))
                );
                let r2 = _.some(this.rep2, obj =>
                    _.some(_.values(obj), value => !_.isEmpty(value))
                );
                let formData = new FormData();
                formData.append('app_id', this.app_id);
                formData.append('bor_id', this.bor_id);
                formData.append('rep1', r1 ? JSON.stringify(this.rep1) : '');
                formData.append('rep2', r2 ? JSON.stringify(this.rep2) : '');
                formData.append('att137', this.att.att137);
                formData.append('att138', this.att.att138);
                axios.post("/api/sblaf-post-auth-rep", formData, config)
                    .then((response) => {
                        this.$emit("next");
                        this.$emit('load', -1);
                    })
                    .catch((error) => {
                        this.$emit('load', -1);
                        this.$emit('error', error);
                    });
            },

            removeRep2() {
                this.rep0 = 0;
                this.rep2 = {
                    fname: null,
                    mname: null,
                    lname: null,
                    suffix_code: null,
                    id_code: null,
                    id_num: null,
                    date_birth: null,
                    gender_id: null,
                    rep_type_id: null,

                    mobile: null,
                    email: null,
                    landline: null,
                };
            },
            checkMIME(file) {
                const mimeConfig = {
                    img: ['image/jpeg', 'image/png', 'image/jpg'],
                    pdf: ['application/pdf'],
                    video: [
                        'video/mov', 'video/mpeg4', 'video/mp4', 'video/avi',
                        'video/wmv', 'video/mpegps', 'video/flv', 'video/3ggp',
                        'video/3gp', 'video/hevc', 'video/wbem', 'video/dnxhr',
                        'video/prores', 'video/cineform', 'video/quicktime'
                    ]
                };
                const fileType = file.type.toLowerCase();
                const category = _.findKey(mimeConfig, types => _.includes(types, fileType));
                return category || fileType;
            },
            viewAttachFile(file, title = "Government Issued ID", modal = '#modalFile') {
                this.attachFile.url = window.URL.createObjectURL(file);
                this.attachFile.type = this.checkMIME(file);
                this.attachFile.title = title;
                $(modal).modal('show');
            },
            swalWarning(msg) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Warning',
                    text: msg,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },
            uploadAttach(e, key) {
                const file = e.target.files[0];
                const supportedType = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
                const supportedSize = 1024 * 1024 * 10; // 10MB
                if (file) {
                    const fileType = file.type.toLowerCase();
                    const fileSize = file.size;
                    if (!supportedType.includes(fileType)) {
                        this.swalWarning('You are attaching unsupported file format');
                        this.att[key] = '';
                    } else if (fileSize > supportedSize) {
                        this.swalWarning('Exceeded the maximum file size required');
                        this.att[key] = '';
                    } else {
                        this.att[key] = file;
                    }
                } else {
                    this.att[key] = '';
                }
            },
            browseRef(id) {
                document.getElementById(id).click();
            },
            withPopper(dropdownList, component, {
                width,
                top,
                left
            }) {
                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;

                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: "top",
                    modifiers: [{
                            name: "offset",
                            options: {
                                offset: [0, -1],
                            },
                        },
                        {
                            name: "toggleClass",
                            enabled: true,
                            phase: "write",
                            fn({
                                state
                            }) {
                                component.$el.classList.toggle(
                                    "drop-up",
                                    state.placement === "top"
                                );
                            },
                        },
                    ],
                });
                return () => popper.destroy();
            },
        },

        mounted() {},
    };
</script>

<style scoped>
</style>